export default __webpack_public_path__ + "static/chibawanlogo-caee713724c40fc77a69c30cd40d8d6c.png";